// waiting for commit of https://github.com/Leaflet/Leaflet/pull/6118

import { GridLayer} from 'leaflet/src/layer/tile/GridLayer';

GridLayer.prototype._setView = function (center, zoom, noPrune, noUpdate) {
    var tileZoom = this._clampZoom(Math.round(zoom / this.options.zoomSnap) * this.options.zoomSnap);
    if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
        (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
        tileZoom = undefined;
    }

    var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);

    if (!noUpdate || tileZoomChanged) {

        this._tileZoom = tileZoom;

        if (this._abortLoading) {
            this._abortLoading();
        }

        this._updateLevels();
        this._resetGrid();

        if (tileZoom !== undefined) {
            this._update(center);
        }

        if (!noPrune) {
            this._pruneTiles();
        }

        // Flag to prevent _updateOpacity from pruning tiles during
        // a zoom anim or a pinch gesture
        this._noPrune = !!noPrune;
    }

    this._setZoomTransforms(center, zoom);
};
